export class EmailBody {
  text!: string;
}
